/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import { Container, BoxUpload, BoxSendButton } from './styles';

export default function BoxUploadAjuda({ setFileValue }) {
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();

  const changeLogo = event => {
    setFileValue(event.target.files[0]);
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    if (file) {
      setFileName(file.name);
    }
  }, [file]);

  return (
    <Container>
      <BoxUpload id="BoxUpload">
        <div className="formContainer" id="fileUploadForm">
          <label htmlFor="perfilUpload">
            <input
              type="file"
              accept=".xlsx,.xls,.pdf,.ods,.csv,.jpeg,.jpg,.png,.docx,.doc"
              id="perfilUpload"
              onChange={e => {
                changeLogo(e);
              }}
            />
          </label>

          {file ? (
            <span className="fileUploadText">
              <b>Arquivo selecionado:</b> {file.name}
              <br />
            </span>
          ) : (
            <span className="fileUploadText">
              Busque o arquivo para <br /> fazer upload.
              <br />
            </span>
          )}

          <BoxSendButton>
            <button type="button">Enviar novo arquivo</button>
          </BoxSendButton>
        </div>
      </BoxUpload>
    </Container>
  );
}
